module.exports = __webpack_public_path__ + "static/media/thinking.1e9792a2.gif";